import { createSlice } from '@reduxjs/toolkit';

const toastSlice = createSlice({
  name: 'toast',
  initialState: {
    messages: [],
  },
  reducers: {
    showToast: (state, action) => {
      const { message, type = 'info' } = action.payload;
      // Use a counter-based id to stay deterministic (no Date.now in reducers)
      const id = state.messages.length + 1 + Math.floor(Math.random() * 100000);
      state.messages.push({ id, message, type });
    },
    dismissToast: (state, action) => {
      state.messages = state.messages.filter(m => m.id !== action.payload);
    },
  },
});

export const { showToast, dismissToast } = toastSlice.actions;

export const selectToasts = (state) => state.toast.messages;

export default toastSlice.reducer;
